import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wallet"
const WalletIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M13.875 13.114C14.496 13.114 15 13.618 15 14.239S14.496 15.364 13.875 15.364 12.75 14.86 12.75 14.239 13.254 13.114 13.875 13.114" />
          <path
            fillRule="evenodd"
            d="M18.172 6C18.92 6.085 19.5 6.719 19.5 7.489V9.364H21C21.828 9.364 22.5 10.036 22.5 10.864V17.614C22.5 18.442 21.828 19.114 21 19.114H19.5V20.989C19.5 21.817 18.828 22.489 18 22.489H3C2.172 22.489 1.5 21.817 1.5 20.989V7.489C1.5 6.719 2.08 6.085 2.828 6zM3 20.989H18V19.114H11.25C10.422 19.114 9.75 18.442 9.75 17.614V10.864C9.75 10.036 10.422 9.364 11.25 9.364H18V7.494H16.343L16.34 7.488H6.935L6.963 7.493H5.328V7.49H3zM11.25 17.614H21V10.864H11.25z"
            clipRule="evenodd"
          />
          <path d="M13.362 2.291C14.072 1.913 14.954 2.161 15.362 2.856L16.325 4.5H14.586L14.066 3.615 12.407 4.5H9.216z" />
        </svg>
      }
    </span>
  )
}
export default WalletIcon
